/**
 * Color Linker — Collection Card Swatch Click Handler
 * Updates card image, price, and links on swatch click.
 * No API calls — all data comes from data-* attributes set in Liquid.
 */

(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    // Only act on swatch clicks
    const swatch = e.target.closest('[data-color-swatch]');
    if (!swatch) return;

    e.preventDefault();

    // Scope everything to this card only
    const card = swatch.closest('[data-color-card]');
    if (!card) return;

    const productUrl          = swatch.dataset.productUrl;
    const productImage        = swatch.dataset.productImage;
    const productSrcset       = swatch.dataset.productSrcset;
    const productPrice        = swatch.dataset.productPrice;
    const productComparePrice = swatch.dataset.productComparePrice;

    // 1. Swap main card image
    const cardImage = card.querySelector('[data-card-image]');
    const cardSecondImage = card.querySelector('[data-card-second-image]');

    if (cardImage && productImage) {
      cardImage.src = productImage;
      if (productSrcset) {
        cardImage.srcset = productSrcset;
      }
    }
    if (cardSecondImage) {
      cardSecondImage.src = productImage;
      if (productSrcset) {
        cardSecondImage.srcset = productSrcset;
      }
    }

    // 2. Swap price display
    const priceWrapper = card.querySelector('[data-card-price]');
    if (priceWrapper && productPrice) {
      if (productComparePrice) {
        // On sale: show compare price struck through + sale price
        priceWrapper.innerHTML = `
          <div class="price price--on-sale">
            <div class="price__container">
              <div class="price__sale">
                <span class="visually-hidden visually-hidden--inline">Prix habituel</span>
                <span><s class="price-item price-item--regular">${productComparePrice}</s></span>
                <span class="visually-hidden visually-hidden--inline">Prix promotionnel</span>
                <span class="price-item price-item--sale price-item--last">${productPrice}</span>
              </div>
            </div>
          </div>`;
      } else {
        // Regular price
        priceWrapper.innerHTML = `
          <div class="price">
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Prix habituel</span>
                <span class="price-item price-item--regular">${productPrice}</span>
              </div>
            </div>
          </div>`;
      }
    }

    // 3. Update card title link href
    const cardLinks = card.querySelectorAll('[data-card-link]');
    cardLinks.forEach(function (link) {
      link.href = productUrl;
    });

    // 4. Move active swatch highlight
    card.querySelectorAll('[data-color-swatch]').forEach(function (s) {
      s.classList.remove('active-swatch');
    });
    swatch.classList.add('active-swatch');
  });


  document.addEventListener('change', function (e) {
    const input = e.target.closest('.swatch-input__input');
    if (!input) return;

    const card = input.closest('[data-color-card]');
    if (!card) return;

    const variantImage        = input.dataset.variantImage;
    const variantSrcset       = input.dataset.variantSrcset;
    const variantPrice        = input.dataset.variantPrice;
    const variantComparePrice = input.dataset.variantComparePrice;

    // 1. Swap image
    if (variantImage) {
      const cardImage = card.querySelector('[data-card-image]');
      if (cardImage) {
        cardImage.src = variantImage;
        if (variantSrcset) cardImage.srcset = variantSrcset;
      }

      const cardSecondImage = card.querySelector('[data-card-second-image]');
      if (cardSecondImage) {
        cardSecondImage.src = variantImage;
        if (variantSrcset) {
          cardSecondImage.srcset = variantSrcset;
        }
      }
    }

    // 2. Swap price
    const priceWrapper = card.querySelector('[data-card-price]');
    if (priceWrapper && variantPrice) {
      if (variantComparePrice) {
        priceWrapper.innerHTML = `
          <div class="price price--on-sale">
            <div class="price__container">
              <div class="price__sale">
                <span class="visually-hidden visually-hidden--inline">Prix habituel</span>
                <span><s class="price-item price-item--regular">${variantComparePrice}</s></span>
                <span class="visually-hidden visually-hidden--inline">Prix promotionnel</span>
                <span class="price-item price-item--sale price-item--last">${variantPrice}</span>
              </div>
            </div>
          </div>`;
      } else {
        priceWrapper.innerHTML = `
          <div class="price">
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Prix habituel</span>
                <span class="price-item price-item--regular">${variantPrice}</span>
              </div>
            </div>
          </div>`;
      }
    }

    // 3. Move active swatch highlight
    card.querySelectorAll('.swatch-input__input').forEach(function (s) {
      s.classList.remove('active-swatch');
    });
    input.classList.add('active-swatch');
  });

})();